import _ from "lodash";
import LayoutUtils from "./LayoutUtils";

/** Places each element into its on own group **/
class SingleElementGroupingStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
  }

  apply(/** BlockLayout **/ blockLayout) {
    let elements = blockLayout.elementData;

    _.each(elements, function (elementData) {
      blockLayout.createGroup(elementData.id, elementData);
    });
  }
}

export default SingleElementGroupingStrategy;
